import React from "react";
import { FiatPrice, RewardsAccount, RewardsPrice } from "redmond";
import { isCorpTenant } from "@capone/common";
import { Typography } from "@material-ui/core";
import { formatCurrency, formatRewards } from "../../state/utils";
import { config } from "../../../../api/config";

const getPortalName = () =>
  isCorpTenant(config.TENANT)
    ? "Capital One Business Travel"
    : "Capital One Travel";

const getFunnelName = () =>
  isCorpTenant(config.TENANT) ? "hotel and flight" : "hotel and flight package";

export const PACKAGE_BANNER_EARN_TEXT = (
  packageDiscount: FiatPrice | undefined,
  earn: RewardsPrice | undefined,
  selectedCardPaymentRewardsAccount: RewardsAccount | undefined
) => (
  <Typography className="package-discount-banner-content">
    {packageDiscount?.value ? (
      <>
        <strong>Save a total of {formatCurrency(packageDiscount)}</strong>
        {!!earn && !!selectedCardPaymentRewardsAccount ? " and" : ""}{" "}
      </>
    ) : (
      ""
    )}
    {!!earn?.value && !!selectedCardPaymentRewardsAccount && (
      <>
        <strong>
          {packageDiscount?.value ? "e" : "E"}arn {formatRewards(earn)}
        </strong>{" "}
        with {selectedCardPaymentRewardsAccount.productDisplayName}{" "}
      </>
    )}
    when you book this {getFunnelName()} through {getPortalName()}.
  </Typography>
);
